import type { LogoutResponse } from '@outsource/shared/auth/me';
import { History, LogOut } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { api } from '../../lib/api';
import { cn } from '../../lib/cn';
import { useMe } from '../../lib/session';
import { Icon } from '../ui/Icon';

/** Ends the session here and in Keycloak (decisions-log W8). */
export async function signOut(): Promise<void> {
  const { redirectUrl } = await api.post<LogoutResponse>('/auth/logout');
  window.location.assign(redirectUrl);
}

interface UserMenuProps {
  readonly open: boolean;
  readonly onToggleActivity: () => void;
}

/**
 * Bottom row of the sidebar: who is signed in, «Активность» and «Выйти» as icons (V120 amended).
 * Local mode has no login (W1), so only «Активность» is there.
 */
export function UserMenu({ open, onToggleActivity }: UserMenuProps) {
  const me = useMe();
  const user = me.mode === 'online' ? me.user : null;
  const name = user ? user.displayName || user.email : null;
  return (
    <div className={cn('flex gap-1 border-t border-border-1 px-2 py-1.5', open ? 'items-center' : 'flex-col items-center')}>
      {open && (
        <span className="flex min-w-0 flex-1 flex-col px-2.5 text-[12px] leading-tight">
          {user && name && (
            <>
              <span className="overflow-hidden text-ellipsis whitespace-nowrap font-semibold text-fg-1">{name}</span>
              {name !== user.email && <span className="overflow-hidden text-ellipsis whitespace-nowrap text-fg-3">{user.email}</span>}
            </>
          )}
        </span>
      )}
      <IconButton icon={History} label="Активность" onClick={onToggleActivity} />
      {user && <IconButton icon={LogOut} label="Выйти" onClick={() => void signOut()} />}
    </div>
  );
}

function IconButton({ icon, label, onClick }: { readonly icon: LucideIcon; readonly label: string; readonly onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      aria-label={label}
      className="grid size-8 flex-none place-items-center rounded-ctl border-0 bg-transparent text-fg-2 hover:bg-neutral-100"
    >
      <Icon icon={icon} />
    </button>
  );
}
